import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./components/pages/Home";
import Chamada from "./components/pages/Chamada";
import ChamadaIpu from "./components/pages/ChamadaIpu";
import Pausa from "./components/pages/Pausa";
import GestaoPausa from "./components/pages/GestaoPausa";
import Agente from "./components/pages/Agente";
import Dashboard from "./components/pages/Dashboard";
import Registada from "./components/pages/Registada";
import ChamadaMovicel from "./components/pages/ChamadaMovicel";
 import NextChat from "./components/pages/NextChat";
 import Turno from "./components/pages/Turno";
 import AddChamadaMovicel from "./components/pages/AddChamadaMovicel";
 import Deep from "./components/pages/Escala";
 import RelatorioLaee from "./components/pages/RelatorioLaee";
 import RelatorioIpu from "./components/pages/RelatorioIpu";
 import Biblioteca from "./components/pages/Biblioteca";
 import MeusTickets from "./components/pages/MeusTickets";
 import Projeto from "./components/pages/Projeto";
 import ProjetoDetalhes from "./components/pages/ProjetoDetalhes";
 import Iniciativa from "./components/pages/Iniciativa";
 import Objetivos from "./components/pages/Objetivos";
 import Direcao from "./components/pages/Direcao";
 import Tarefa from "./components/pages/Tarefa";
 import Tarefadetalhe from "./components/pages/Tarefadetalhe";
 import AprovarTarefa from "./components/pages/AprovarTarefa";
  
 import LogisticaSala from "./components/pages/Logistica/LogisticaSala";
 
 import Transacoes from "./components/pages/Transacoes";
 import LogisticaVeiculo from "./components/pages/Logistica/LogisticaVeiculo";
 import Aprovacao from "./components/pages/Logistica/Aprovacao";

 import UserSalario from "./components/pages/UserSalario";
 import Usuario from "./components/pages/Usuario";
 import Aprovacaofaltas from "./components/pages/Aprovacaofaltas";
 import Ferias from "./components/pages/Ferias";
 import Aprovacaoferias from "./components/pages/Aprovacaoferias";
 import TarefaDiaria from "./components/pages/TarefaDiaria";
 import AprovacaoferiasSecretariado from "./components/pages/AprovacaoferiasSecretariado";
  import DashboardDirecao from "./components/pages/DashboardDirecao";
  import DashboardAdministracao from "./components/pages/DashboardAdministracao";
  import Custos from "./components/pages/Custos";
  import FichaTecnica from "./components/pages/FichaTecnica";
    import RelatorioAssiduidade from "./components/pages/RelatorioAssiduidade";
    import RelatorioSemanal from "./components/pages/RelatorioSemanal";
 

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Rota de login fora da estrutura protegida */}
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
       
        
      
 
        {/* Rotas protegidas dentro de Home */}
        <Route
          path="/*"
          element={
         
          
              <ProtectedRoute>
                         <Home />
                         </ProtectedRoute>
 

          }
        >
      <Route path="login" element={<Login />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="chat" element={<NextChat />} />


      <Route path="biblioteca" element={<Biblioteca />} />
      
       {/*        ADMINISTRAÇÃO                     */}
      <Route path="iniciativas" element={<Iniciativa />} />
      <Route path="objectivos" element={<Objetivos />} />
      <Route path="direcoes" element={<Direcao />} />
      <Route path="colaboradores" element={<UserSalario />} />
      <Route path="dashboard_administracao" element={<DashboardAdministracao />} />
      <Route path="custos" element={<Custos />} />



       {/*        DIRETOR                     */}
       <Route path="aprovar_faltas" element={<Aprovacaofaltas />} />
       <Route path="aprovacao_ferias" element={<Aprovacaoferias />} />
       <Route path="dashboard_diretor" element={<DashboardDirecao />} />
       <Route path="tarefas_aprovacao" element={<AprovarTarefa />} />


       {/*        SECRETARIADO                     */}
      <Route path="aprovacao_ferias_secretariado" element={<AprovacaoferiasSecretariado />} />
      <Route path="aprovar" element={<Aprovacao />} />




       {/*        ADMIN                     */}
       <Route path="usuarios" element={<Usuario />} />
       


        {/*        GERAL                     */}
      <Route path="projectos" element={<Projeto />} />
      <Route path="tarefas" element={<Tarefa />} />
      <Route path="tarefas_diarias" element={<TarefaDiaria />} />
      <Route path="assiduidade_transacoes" element={<Transacoes />} />
      <Route path="transporte" element={<LogisticaVeiculo />} />
      <Route path="sala_reuniao" element={<LogisticaSala />} />
       <Route path="ferias" element={<Ferias />} />

<Route path="relatorio_semanal" element={<RelatorioSemanal />} />


      <Route path="tarefas/:id" element={<Tarefadetalhe />} />
       <Route path="projectos/:id" element={<ProjetoDetalhes />} />
              <Route path="ficha_tecnica" element={<FichaTecnica />} />
              <Route path="assiduidade" element={<RelatorioAssiduidade />} />
      
        </Route>
      </Routes>
    </Router>
  );
};

export default App;

